import { Component, Input } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import { LanguageServices } from "src/app/services/LanguageServices";
import { LanguageService } from "typescript";

@Component({
    selector: 'webhook-log-output',
    templateUrl: './webhook-log-output.component.html',
    styleUrl: './webhook-log-output.component.scss',
    standalone: false
})




export class WebhookLogOutputComponent {



  constructor(private message:NzMessageService, private ls:LanguageServices){

  }
  @Input() data: Record<string, any> = {};

  searchValue = '';
  sortKey: 'key' | 'value' = 'key';
  sortOrder: 'ascend' | 'descend' | null = null;
  pageIndex = 1;
  pageSize = 10;

  onClick(value,value1){

  }

  trackByKey(index: number, item: any): string {
    return item.key;
  }


  get entries() {
    if ( this.data == null) return [];
    
    let arr = Object.entries(this.data).map(([key, value]) => ({ key, value }));
    
    // filtro
    if (this.searchValue) {
      arr = arr.filter(item =>
        item.key.toLowerCase().includes(this.searchValue.toLowerCase()) ||
        String(item.value).toLowerCase().includes(this.searchValue.toLowerCase())
      );
    }

    // ordenação
    if (this.sortOrder) {
      arr = arr.sort((a, b) => {
        const valA = String(a[this.sortKey]).toLowerCase();
        const valB = String(b[this.sortKey]).toLowerCase();
        if (valA < valB) return this.sortOrder === 'ascend' ? -1 : 1;
        if (valA > valB) return this.sortOrder === 'ascend' ? 1 : -1;
        return 0;
      });
    }

    return arr;
  }

  get pagedEntries() {
    const start = (this.pageIndex - 1) * this.pageSize;
    return this.entries.slice(start, start + this.pageSize);
  }

  prepareValue(value:any){
      if ( value instanceof Object || value instanceof Array){
        return JSON.stringify(value);
      }else{
        return value;
      }
  }

  isPreContent(value: any): boolean {
    if (!value) return false;
    const str = String(value).trim();

    return (
      str.startsWith('{') || str.startsWith('[') || // JSON
      str.startsWith('<') ||                        // XML
      /^select\s+/i.test(str)                       // SQL SELECT
    );
  }

  exportCSV() {
    const rows = this.entries.map(e => `"${e.key}","${String(e.value).replace(/"/g, '""')}"`);
    const csvContent = ['Key,Value', ...rows].join('\n');

    // cria um blob e dispara download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'json-data.csv';
    a.click();
    URL.revokeObjectURL(url);
  }

  copyText(text: string): void {
    navigator.clipboard.writeText(this.prepareValue(text)).then(() => {
      this.message.success(this.ls.instant('content.copied'));
    });
  }


}

